import { useTranslation } from 'next-i18next';

import { FormSidebarItem } from '@/shared/components/layout/FormSidebar';

export const useAttributeGroups = () => {
  const { t } = useTranslation('entities/assets', { keyPrefix: 'group' });

  const assetGroups: FormSidebarItem[] = [
    { title: t('general'), icon: 'info' },
    { title: t('details'), icon: 'list-bullets' },
    { title: t('ownership'), icon: 'scales' },
    { title: t('profitability'), icon: 'chart-line-up' },
    { title: t('analytics'), icon: 'chart-bar' },
    { title: t('documents'), icon: 'files' },
  ];

  return assetGroups;
};
